import { withProps, StyledElement } from '@udecode/plate';

import { CSSProp } from 'styled-components';
import styles from 'src/shared/styles/richText';

const Paragraph = withProps(StyledElement, {
  as: 'p',
  styles: {
    root: styles.p as CSSProp,
  },
});

export default Paragraph;
